module.exports = __webpack_public_path__ + "static/img/11.9ea1bb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/11.jpg
// module id = bRe7
// module chunks = 0